/**
 * useRightSidebar Hook
 * 
 * Hook for pages to register their sidebar content.
 * Content is registered when component mounts and updated when sections change.
 * Cleared on unmount.
 * 
 * Uses only the setters context to avoid re-render loops.
 */

import { useEffect } from 'react';
import { useRightSidebarSetters, type SidebarSection } from './RightSidebarContext';

export function useRightSidebar(sections: SidebarSection[]) {
    const { setSections, clearSections } = useRightSidebarSetters();

    useEffect(() => {
        // Set sections when the component mounts or sections change
        setSections(sections);

        return () => {
            clearSections();
        };
    }, [sections, setSections, clearSections]);
}

export type { SidebarSection };